// import {
//   requestBannerList,
// } from '@/api/banner';

const state = {
  bannerMode: null,
  bannerList: null,
};

const getters = {
  bannerMode: (state) => state.bannerMode,
  bannerList: (state) => state.bannerList,
};

const actions = {
  // async getBannerList({ commit, dispatch }) {
  //   await dispatch('setIsLoading', true, { root: true });
  //   const result = await requestBannerList();
  //   commit('getBannerList', result.data);
  //   await dispatch('setIsLoading', false, { root: true });
  // },
  async getBannerList({ commit }) {
    // await dispatch('setIsLoading', true, { root: true });
    // const result = await requestBannerList();
    const result = {
      list: [
        {
          file_name: '/img/banner/pc01.png?v=1',
          sp_file_name: '/img/banner/sp01.png?v=2',
        },
      ],
    };
    console.log(result);
    commit('getBannerList', result);
    // await dispatch('setIsLoading', false, { root: true });
  },
};

const mutations = {
  getBannerList(state, bannerList) {
    state.bannerList = bannerList;
    state.bannerMode = bannerList.mode;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
